import type { ReactNode } from 'react'

import type { AuthFeatureItem } from './auth-layout.interface'

export const AuthFeatureItemAtom: React.FC<AuthFeatureItem> = ({
  icon: Icon,
  title,
  description,
}): ReactNode => (
  <div className="auth-feature-item flex items-start gap-3 lg:gap-4">
    <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/15">
      <Icon className="h-5 w-5 text-white" />
    </div>
    <div className="space-y-1">
      <h3 className="text-base font-semibold text-white">{title}</h3>
      <p className="auth-feature-description text-sm leading-relaxed text-white">{description}</p>
    </div>
  </div>
)
